/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon32Regular = forwardRef('ArrowDim1HIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "m27.583 17-.058.06-5.732 5.733a1 1 0 0 0 1.414 1.414l5.733-5.732a3.5 3.5 0 0 0 0-4.95l-5.733-5.732a1 1 0 1 0-1.414 1.414l5.732 5.732c.02.02.04.04.058.061H4.418l.057-.06 5.732-5.733a1 1 0 0 0-1.414-1.414l-5.732 5.732a3.5 3.5 0 0 0 0 4.95l5.732 5.732a1 1 0 0 0 1.414-1.414l-5.732-5.732L4.417 17h23.166Z" })));
});
